import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  Optional,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { ConnectedOverlayDirective } from '../../core/overlay/overlay-directives';
import { NestedTemplatesHistoryService } from './dropdown-nested-templates/nested-templates-history.service';

export enum DropdownWidth {
  SmallXX = '150px',
  SmallX = '200px',
  Small = '250px',
  Medium = '300px',
  Large = '350px',
  LargeX = '400px',
  LargeXX = '450px',
  LargeXXX = '500px',
  LargeXXXX = '550px',
  LargeXXXXX = '600px',
  FullWidth = 'unset',
}

/**
 * @description Wrapper element to ensure proper styling.
 *
 *
 *  __> INPUTS:__
 *  - __width__: _DropdownWidth (enum)_ - use __FullWidth__ to set dropdown width to trigger element (e.g. input) width
 *
 */

@Component({
  selector: 'rt-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.width]': 'width',
  },
  providers: [NestedTemplatesHistoryService],
})
export class DropdownComponent {
  @Input() public width: DropdownWidth = DropdownWidth.Medium; // predefined dropdown widths

  @ViewChild('defaultTpl', { static: true }) public defaultTpl: TemplateRef<any>;

  public template: TemplateRef<any>;

  constructor(
    @Optional() private connectedOverlayDirective: ConnectedOverlayDirective,
    private cdRef: ChangeDetectorRef,
    private nestedTemplatesHistory: NestedTemplatesHistoryService,
  ) {}

  public setNestedTemplate(templateRef: TemplateRef<any>) {
    this.template = this.nestedTemplatesHistory.pushState(templateRef);
    this.forceViewUpdate();
  }

  public prevTemplate(): void {
    this.template = this.nestedTemplatesHistory.back();
    this.forceViewUpdate();
  }

  public ngOnInit(): void {
    this.template = this.nestedTemplatesHistory.pushState(this.defaultTpl);
    this.cdRef.detectChanges();
  }

  private forceViewUpdate(): void {
    this.cdRef.detectChanges();
    this.connectedOverlayDirective?.updatePositionWithoutRedrawing();
  }
}
